import React, { createRef } from 'react';
import { IonActionSheet, IonBackButton, IonButtons, IonListHeader, IonCardHeader, IonCardContent, IonCardTitle, IonCardSubtitle, IonCard, IonFab, IonFabButton, IonIcon, IonContent, IonHeader, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar, withIonLifeCycle } from '@ionic/react';
import '../styles/Terms.scss';
import Utilities from '../Utilities';

class Practice extends React.Component {

    constructor(props) {
        super(props);
        Utilities.trackEvent("Terms", "Terms Page View");
    }

    render() {
        return (
            <IonPage data-page="terms">
                <IonHeader>
                    <IonToolbar>
                        <IonButtons slot="start">
                            <IonBackButton text={window.ln.back} defaultHref="/" onClick={() => { this.props.history.goBack(); }} />
                        </IonButtons>
                        <IonTitle>Terms</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent>

                    <div className="content">

                        <h2>Last updated</h2>
                        <p>Terms and Conditions (Last updated 28/03/2023)</p>
                        <p>Privacy Policy (Last updated 28/03/2023)</p>

                        <h2>Changes to our Terms & Conditions and Privacy Policy</h2>
                        <p>We reserve the right to change our Terms & Conditions and Privacy Policy at any time.</p>
                        <p>Your access to and use of the app is conditioned upon your acceptance of and compliance with these Terms and Conditions and Privacy Policy. If you disagree with any part then you do not have permission to use our service.</p>

                        <h2>Terms & Conditions</h2>

                        <p>Your use of the Service is at your sole risk. The Service is provided on an "AS IS" and "AS AVAILABLE" basis. The Service is provided without warranties of any kind, whether express or implied.</p>

                        <p>We do not warrant that the Service will function uninterrupted, secure, or available at any particular time or location or any errors or defects will be corrected</p>

                        <h2>In-app products</h2>

                        <p>Payments for in-app products, and subscriptions sold in this application are processed by Apple and Google, we do not store any card information.</p>

                        <p>Some parts of the Service are billed on a subscription basis ("Subscription(s)"). You will be billed in advance on a recurring and periodic basis ("Billing Cycle"). Billing Cycles are set on a monthly and yearly basis.</p>
                        <p>At the end of each Billing Cycle, your Subscription will automatically renew under the exact same conditions unless you or us cancel it.</p>
                        <p>You can cancel your Subscription renewal in the following ways:</p>
                        <ul>
                            <li>If you used the browser to subscribe via Stripe then you can cancel your plan from all your devices by going to the Subscription option in the app settings</li>
                            <li>If you used AppStore (iOS) to subscribe then please follow these instructions to cancel your plan: <a href="https://support.apple.com/en-us/HT202039">https://support.apple.com/en-us/HT202039</a></li>
                            <li>If you used Google Play (Android) to subscribe then please follow these instructions to cancel your plan: <a href="https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en">https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en</a></li>
                        </ul>
                        <p>Should automatic billing fail to occur for any reason the aforementioned providers may attempt to charge the selected payment method(s) multiple times. Your subscription will remain intact for 7 days after which your subscription is automatically canceled.</p>

                        <h2>Refunds</h2>

                        <p>You may be eligible to request a refund for in-app purchases (from Apple or Google), or other types of purchases directly from Flashcards made Simple (depending on your country).</p>

                        <p>If unsure you can contact us to see if you can request a refund. After requesting a refund, your premium features will be revoked immediately.</p>

                        <h2>Intellectual Property</h2>

                        <p>We respect the intellectual property rights of others. If you believe that someone infringing on these please contact us.</p>

                        <p>The Service and its original content, features, and functionality are and will remain the exclusive property of Flashcards made Simple. The Service is protected by copyright, trademark, and other laws of both the United Kingdom and foreign countries. Our trademarks and trade dress may not be used in connection with any product or service.</p>

                        <h2>Content (Only applicable if you explicitly share flashcards)</h2>

                        <p>Our Service allows you to post study sets and flashcards ("Content"). You are responsible for the Content that you post on the Service, including its legality. By posting Content on the Service, you confirm that the Content is yours and/or you have the right to use it.</p>

                        <p>We take no responsibility and assume no liability for Content you or any third party posts on the Service. We have the right to monitor all Content provided by the users. Any content stored on the Service will be stored indefinitely unless it is explicitly deleted.</p>

                        <h2>Privacy Policy</h2>

                        <p>By default, no personal information or generated content by you leaves your devices. We never share personal data or generated content unless you explicitly share something.</p>

                        <p>You can sign in using your Dropbox account to backup and sync your data between devices, in this case, your data is uploaded to your Dropbox account, and can only be accessed by people who have access to that account, which should only be you. However, Dropbox does have the means to access this data internally (although it's highly unlikely that they will).</p>

                        <p>You have the option to share flashcards on a set-by-set basis with your friends, your students, or the whole community. In this case information about the shared set, and all included cards are uploaded to our servers, so others can download it and fetch updates for it. If you make changes in the shared study set you will have to press publish again to make the new changes available to others who downloaded your set.</p>

                        <p>In the above case, you will need to set up an account with an email address (never revealed to anyone, just used for login), a username (users will see this when looking at your shared sets), and a password (your password is stored securely in a hashed format in the database, it cannot be converted back to plain text).</p>

                        <p>We use analytics services. These include Google Analytics (<a href="https://analytics.google.com/">analytics.google.com</a>), and Bugsnag (<a href="https://www.bugsnag.com/">bugsnag.com</a>). Personal information and user-generated content are NEVER sent to these services.</p>

                    </div>

                </IonContent>
            </IonPage>
        );
    }

};


export default withIonLifeCycle(Practice);
